import React from "react";

import "../../styles/garage/garage-main.css";
import dashboard from "../../assets/images/mockup.png";
import { Link } from "react-router-dom";


export default function Hero() {
    return (
        <section className="hero">
            <div className="hero-words">
                

                <h1>
                    Garage Management
                    <br />
                    made <span>Smarter.</span>
                </h1>

                <p>
                    Everything you need to run your garage efficiently,
                    <br />
                    from invoices and work orders to staff and finances.
                </p>

                <div className="hero-buttons">
                    <button className="hero-button themed">
                        <a href="#pricing">Start Free Trial</a>
                    </button>

                    <button className="hero-button secondary">
                        <a href="#features">Learn More</a>
                    </button>
                </div>

                <div className="hero-note">
                    No credit card required
                </div>
            </div>


            <div className="hero-image"> <img src={dashboard} alt="My Car Kenya garage management dashboard" className="dashboard-image" /> </div>
        </section>
    );
}
